export const listDefaultItem = [
  {
    nom: 'Assurance Aro',
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    imageUrl: require(`../../../ressources/images/PhotoSlide.png`),
    description:
      'Une application sur mesure conçue pour vous offrir un service qui simplifie la vie',
  },
];
